module.exports = __webpack_public_path__ + "welcome.jpg?65fa78bb18e1f32bf9749ec56a928947";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/welcome.jpg
// module id = 484
// module chunks = 0